import React from "react";
import { SiHtml5, SiJavascript, SiCss3, SiMarkdown } from "react-icons/si";
import { FaFileExcel, FaFileWord, FaFilePdf, FaFileImage } from "react-icons/fa";
import { AiFillFile } from "react-icons/ai";
import { FiFolder } from "react-icons/fi";

export const obtenerIconoPorExtension = (extension, modoEmulador = false) => {
  const colorEmulador = "#2a4c94";

  if (extension !== "") {
    switch (extension) {
      case "json":
        return <img src="/assets/images/iconos/file24.svg" alt="Archivo" />;
      case "csv":
        return <img src="/assets/images/iconos/file24.svg" alt="Archivo" />;
      case "html":
        return <img src="/assets/images/iconos/file24.svg" alt="Archivo" />;
      case "js":
        return <img src="/assets/images/iconos/file24.svg" alt="Archivo" />;
      case "css":
        return <img src="/assets/images/iconos/file24.svg" alt="Archivo" />;
      case "md":
        return <img src="/assets/images/iconos/file24.svg" alt="Archivo" />;
      case "txt":
      case "doc":
      case "docx":
        return <img src="/assets/images/iconos/file24.svg" alt="Archivo" />;
      case "xls":
      case "xlsx":
        return <img src="/assets/images/iconos/file24.svg" alt="Archivo" />;
      case "pdf":
        return <img src="/assets/images/iconos/file24.svg" alt="Archivo" />;
      case "jpg":
      case "jpeg":
      case "png":
        return <img src="/assets/images/iconos/file24.svg" alt="Archivo" />;
      case "mp3":
      case "wav":
      case "mp4":
      case "avi":
      case "zip":
      case "rar":
        return <img src="/assets/images/iconos/file24.svg" alt="Archivo" />;
      default:
        return <img src="/assets/images/iconos/folder24.svg" alt="Archivo" />;
    }
  } else {
    return <img src="/assets/images/iconos/folder24.svg" alt="Archivo" />;
  }
};

export default obtenerIconoPorExtension;
